import {Trans} from '@lingui/macro';
import React, {FC, ReactNode} from 'react';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {RuleDefaultCardTypesEnum} from '../../ruleActionConditionHelpers';
import {RuleAction, SnoozeAction} from '../../ruleActionModel';
import {RuleActionDefinition} from '../../ruleParameterModel';
import {RuleActionIcon} from '../ruleActionIcon';
import {
  MultilineRuleParameterCardDefaultTitleStyled,
  RuleMultilineParameterCard,
} from '../ruleMultilineParameterCard';
import {renderGenericRuleParameters} from './ruleDefaultActionConditionCard';

/*
 * Props.
 */

interface RuleSnoozeActionCardProps {
  action: SnoozeAction;
  actionDefinition: RuleActionDefinition | undefined;
  isDisabled?: boolean;
  interactionId?: string;
  errorMessage?: ReactNode;
  onUpdate: HandlerOf<RuleAction>;
  onDelete?: HandlerOf<RuleAction>;
}

/*
 * Component.
 */

export const RuleSnoozeActionCard: FC<RuleSnoozeActionCardProps> = (props) => {
  const {action, actionDefinition, isDisabled, interactionId, errorMessage, onUpdate, onDelete} = props;

  // This should not happen, but safety check.
  const errorLabel = <Trans id="manifest-action-not-found">Action {action.type} not found</Trans>;
  if (!actionDefinition) {
    return <RuleMultilineParameterCard icon={<RuleActionIcon id={action.type} />} title={errorLabel} />;
  }

  const onCancel = onDelete && !isDisabled ? () => onDelete(action) : undefined;

  const {
    parameters: [presetParam, ...otherParameters],
    collapsableParameters,
  } = renderGenericRuleParameters(
    action,
    actionDefinition,
    RuleDefaultCardTypesEnum.ACTION,
    onUpdate,
    actionDefinition.parameters,
    isDisabled,
  );

  const title = (
    <>
      <MultilineRuleParameterCardDefaultTitleStyled>
        {actionDefinition.name}
      </MultilineRuleParameterCardDefaultTitleStyled>
      {presetParam}
    </>
  );

  return (
    <RuleMultilineParameterCard
      interactionId={interactionId}
      icon={<RuleActionIcon id={action.type} />}
      title={title}
      onCancel={onCancel}
      collapsableParameters={collapsableParameters}
      errorMessage={errorMessage}
    >
      {otherParameters}
    </RuleMultilineParameterCard>
  );
};
